// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			//resizeWindow();
		});
		//resizeWindow();

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			//scrollDown();
		});

		var start = $('#arriveInput').attr('value');
		var end = $('#departureInput').attr('value');
		var firstClick = 0;

		var limitDate = $('#limitDate').attr('value').split(',');
		$('#datesCalendar').datepicker({
			minDate: start,
			numberOfMonths: 2,
			dateFormat: 'mm/dd/yy',
			maxDate: new Date(limitDate[0], parseInt(limitDate[1]) - 1, 31),
			beforeShowDay: function (date) {
				$.datepicker._defaults.dateFormat = "mm/dd/yy";
				var startDate = $.datepicker.parseDate('mm/dd/yy', start);
				var endDate = $.datepicker.parseDate('mm/dd/yy', end);

				if (date.getTime() == startDate.getTime()) {
					return [true, "start-day"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "end-day"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (firstClick == 0) {
					start = date;
					end = date;
					firstClick = 1;
				} else {
					if (selectedDate <= start) {
						end = start;
						start = date;
					} else {
						end = date;
					}
					firstClick = 0;
				}

				$('#ArriveDay').attr('value', start);
				$('#DepartureDay').attr('value', end);

				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);
			}
		});
		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		// Change position submit button
		function insertAfter(newElement, referenceElement) {
			referenceElement.parentNode.insertBefore(newElement, referenceElement.nextSibling);
		}
		let submitBtn = document.querySelector(".signup-btn");
		let fieldsWrap = document.querySelector(".gdpr-wrap");
		let gpdrWrap = fieldsWrap.getElementsByTagName('div');
		$(submitBtn).appendTo('.fields-wrap');

		// Booking Block
		let reserveButton = document.querySelector('.js-reserve');
		let bookingBlock = document.querySelector('.booking-block');
		let closeBooking = document.querySelector('.js-close');

		reserveButton.addEventListener('click', function (e) {
			bookingBlock.classList.add('open');
			e.preventDefault();
		})
		closeBooking.addEventListener('click', function (e) {
			bookingBlock.classList.remove('open');
			e.preventDefault();
		})

		//Mobile menu
		var mobileNav = document.querySelector('.mobile-navigation');
		var mobileMenu = document.querySelector('.js-menu');

		mobileMenu.addEventListener('click', function(e){
			mobileNav.classList.add('open')
			e.preventDefault()
		})

		var closeMenu = document.querySelector('.close-menu');
		closeMenu.addEventListener('click', function (e) {
			mobileNav.classList.remove("open");
			e.preventDefault();
		})


		//Slick JS
		$('.slideshow__slides').slick({
			dots: false,
			slidesToShow: 1,
			autoplay: false,
			nextArrow: '<button class="slick-arrow slick-next">Next</button>',
			prevArrow: '<button class="slick-arrow slick-prev">Prev</button>'
		});

		setTimeout(function () {
			//$('.slick-prev').prepend('<div class="prev-slick-arrow arrow-icon"><span>&#60;</span></div><div class="prev-slick-img slick-thumb-nav"><img src="/prev.jpg" class="img-responsive"></div>');
			$('.thumb-next').append('<div class="next-slick-img slick-thumb-nav"><img src="/next.jpg" class="img-responsive"></div>');
			//get_prev_slick_img();
			get_next_slick_img();
		}, 500);

		$('.slideshow__slides').on('afterChange', function (event, slick, currentSlide, nextSlide) {
			get_next_slick_img();
		});
		$('.slideshow__slides').on('click', '.slick-prev', function () {
			get_prev_slick_img();
		});
		$('.slideshow__slides').on('click', '.slick-next', function () {
			get_next_slick_img();
		});
		$('.slideshow__slides').on('swipe', function (event, slick, direction) {
			if (direction == 'left') {
				get_prev_slick_img();
			}
			else {
				get_next_slick_img();
			}
		});
		$('.slick-dots').on('click', 'li button', function () {
			var li_no = $(this).parent('li').index();
			if ($(this).parent('li').index() > li_no) {
				get_prev_slick_img()
			}
			else {
				get_next_slick_img()
			}
		});
		function get_prev_slick_img() {
			// For prev img
			var prev_slick_img = $('.slick-current').prev('.slider-image').find('img').attr('src');
			$('.prev-slick-img img').attr('src', prev_slick_img);
			//$('.prev-slick-img').css('background-image', 'url(' + prev_slick_img + ')');
			// For next img
			var prev_next_slick_img = $('.slick-current').next('.slider-image').find('img').attr('src');
			$('.next-slick-img img').attr('src', prev_next_slick_img);
			//$('.next-slick-img').css('background-image', 'url(' + prev_next_slick_img + ')');
		}
		function get_next_slick_img() {
			// For next img
			var next_slick_img = $('.slick-current').next('.slider-image').find('img').attr('src');
			$('.next-slick-img img').attr('src', next_slick_img);
			//$('.next-slick-img').css('background-image', 'url(' + next_slick_img + ')');
			// For prev img
			var next_prev_slick_img = $('.slick-current').prev('.slider-image').find('img').attr('src');
			$('.prev-slick-img img').attr('src', next_prev_slick_img);
			//$('.prev-slick-img').css('background-image', 'url(' + next_prev_slick_img + ')');
		}
		// End
		//Text and slider module
		$('.text-and-slider__slider').slick({
			dots: false,
			slidesToShow: 1,
			autoplay: false,
			fade: true,
			nextArrow: '<button class="slick-arrow slick-next">Next</button>',
			prevArrow: '<button class="slick-arrow slick-prev">Prev</button>'
		});

		//Slider
		//Text and slider module
		$('.slider__images').slick({
			dots: false,
			slidesToShow: 1,
			autoplay: false,
			fade: true,
			arrows: false,
			asNavFor: '.slider__text'
		});

		$('.slider__text').slick({
			dots: false,
			slidesToShow: 1,
			autoplay: false,
			fade: true,
			arrows: true,
			infinite: true,
			dots: false,
			appendArrows: '.sliderArrows',
			asNavFor: '.slider__images',
			slide: '.item',
			nextArrow: '<button class="slick-arrow slick-next">Next</button>',
			prevArrow: '<button class="slick-arrow slick-prev">Prev</button>',
			//mobileFirst:true,
			responsive: [
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false,
						dots: true
					}
				}
			]
		});

		//Slider Background
		$('.slider-background__content').slick({
			dots: false,
			slidesToShow: 1,
			autoplay: true,
			autoplaySpeed:3000,
			speed:700,
			fade: true,
			arrows: true,
			dots:true,
			appendArrows: '.arrowsSlider__holder',
			slide:'.slide-text',
			appendDots: '.backgroundDots',
			nextArrow: '<button class="slick-arrow slick-next slick-text-next">Next</button>',
			prevArrow: '<button class="slick-arrow slick-prev slick-text-prev">Prev</button>',
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						dots: false
					}
				},
				{
					breakpoint: 480,
					settings: {
						
						dots: true,
						arrows:false
					}
				}
			]
		});

		//Gallery shortcode
		$('.gallery__content').slick({
			dots: false,
			slidesToShow: 3,
			autoplay: false,
			arrows: false,
			infinite: true,
			centerMode: true,
			centerPadding: '20%',
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 3,
						infinite: true,
						dots: false
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerPadding: '10%'

					}
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			]
		});

		//Fancybox
		$('.js-rates').fancybox({
			wrapCSS:'fancy-rates',
			tpl: {
				closeBtn: '<div title="Close" class="fancybox-item fancybox-close js-rates-close">Close</div>'
			}
		})

		//Accordion JS
		// Accordion 
		$('.accordion-item button').click(function(e) {
			e.preventDefault();

		var $this = $(this);

		if ($this.hasClass('show')) {
			$this.next().removeClass('show');
			$this.next().slideUp(350);
			$this.removeClass('show');
		} else {
			$this.addClass('show');
			$this.next('.accordion-content').removeClass('show');
			$this.next('.accordion-content').slideUp(350);
			$this.parent().parent().parent().parent().find('.accordion-content').slideUp(350);
			$this.next().toggleClass('show');
			$this.next().slideToggle(350);
			
		}
		});

		// Hover elements
		$('.js-h-item').hover(function (e) {
			e.preventDefault();
			$(this).siblings().removeClass('active');
			$(this).addClass('active');
			let href = $(this).attr('data-target');
			$('.'+href).siblings().removeClass('active');
			$('.'+href).addClass('active');
		});

		$('.point').hover(function(e){
			e.preventDefault();
			$(this).siblings().removeClass('active');
			$(this).addClass('active');
			let href = $(this).attr('id');
			$('.'+href).siblings().removeClass('active');
			$('.'+href).addClass('active');
			
		})


	});

	window.onload = function () {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		})
	};

}());

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	let logo = document.getElementById('logo');
	let logoColor = "assets/svg/Fishermans-Marina-logo.svg";
	let logoWhite = "assets/svg/Fishermans-Marina-logo.svg"
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
				document.getElementById("logo").src = logoColor;
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
				document.getElementById("logo").src = logoColor;
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
			if (!document.body.classList.contains('photos') && !document.body.classList.contains('lake-county')) {
				document.getElementById("logo").src = logoWhite;
			}
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}


